import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

export interface AuditEntryRequestDto {
  page?: number;
  size?: number;
}

export interface AuditEntryResponseDto {
  id: number;
  userId: number;
  username: string;
  action: string;
  resourceType: string;
  entityName: string; // Added entityName field from backend
  resourceId: string;
  details: string;
  ipAddress: string;
  userAgent: string;
  timestamp: string;
  localDateTime?: string | number[] | number; // Added localDateTime field for ZonedDateTime support (string, array, or Unix timestamp)
  status: string; // Changed from success: boolean to status: string
  errorMessage?: string;
  // Additional fields that might be present
  userName?: string;
  userRole?: string;
  methodName?: string;
}

export interface AuditLogsResponse {
  content: AuditEntryResponseDto[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  numberOfElements: number;
}

const API_URL = `${process.env.REACT_APP_API_URL}/audit`;

export const useAuditLogs = (requestDto: AuditEntryRequestDto = {}) => {
  return useQuery({
    queryKey: ['auditLogs', requestDto],
    queryFn: async (): Promise<AuditLogsResponse> => {
      const response = await axios.post(`${API_URL}/get`, {
        page: requestDto.page || 0,
        size: requestDto.size || 10,
      });
      return response.data;
    },
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  });
};

export const getAllAuditLogs = async (requestDto: AuditEntryRequestDto = {}): Promise<AuditLogsResponse> => {
  try {
    const response = await axios.post(`${API_URL}/get`, {
      page: requestDto.page || 0,
      size: requestDto.size || 10,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
